(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/views/gaming-info/gaming-limits.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/views/gaming-info/gaming-limits.js');

'use strict';

svs.player_login.views.GamingLimits = Marionette.View.extend({
  template(data) {
    return svs.player_login.templates.gaming_limits(data);
  },
  ui: {
    nextItem: '.js-next-item',
    prevItem: '.js-prev-item',
    limitItems: '.js-player-login-limits-item'
  },
  events: {
    'click @ui.nextItem': 'nextItem',
    'click @ui.prevItem': 'prevItem'
  },
  templateContext() {
    return {
      showNavigation: this.limits.length > 1,
      hasCasinoLimits: this.hasCasinoLimits,
      hasDepositLimits: this.hasDepositLimits,
      hasTimeLimits: this.hasTimeLimits,
      noLimits: this.limits.length < 1,
      returnUrl: this.options.returnUrl,
      isPnp: this.options.isPnp,
      pnpContinueUrl: this.options.pnpContinueUrl
    };
  },
  modelEvents: {
    sync: 'setSync',
    error: 'setError',
    'change:hasSync': 'render',
    'change:hasError': 'render'
  },
  behaviors: [svs.player_login.behaviors.Navigation],
  model: new svs.player_login.models.GamingLimits(),
  initialize() {
    this.model.fetch();
  },
  setSync() {
    function anyLimit() {
      let limitType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return Object.keys(limitType).some(limitPeriod => limitType[limitPeriod].limit);
    }
    this.hasDepositLimits = anyLimit(this.model.get('deposit') || {});
    this.hasCasinoLimits = anyLimit(this.model.get('casino') || {});
    this.hasTimeLimits = anyLimit(this.model.get('time') || {});
    this.limits = [];
    this.hasDepositLimits && this.limits.push('insättningsgränser');
    this.hasCasinoLimits && this.limits.push('förlustgränser - casino');
    this.hasTimeLimits && this.limits.push('tidsgränser');
    this.model.set('hasSync', true);
  },
  setError() {
    this.model.set('hasError', true);
  },
  animateLimits(listOfLimits, currentItemIndex, nextItemIndex, direction) {
    const itemToHide = listOfLimits.filter(index => index === currentItemIndex);
    const itemToShow = listOfLimits.filter(index => index === nextItemIndex);
    const short = svs.core.detect.breakpoint.lessThan('sm') ? '' : '-short';
    const directionClasses = {
      right: {
        hide: "animate-to-right".concat(short),
        show: "animate-from-left".concat(short)
      },
      left: {
        hide: "animate-to-left".concat(short),
        show: "animate-from-right".concat(short)
      }
    };
    svs.components.animation.add(itemToHide, "animate-hide ".concat(directionClasses[direction].hide, " animate-time-short"), () => {
      itemToHide.addClass('hide');
      itemToHide.removeClass("animate-hide ".concat(directionClasses[direction].hide, " animate-time-short"));
      itemToShow.removeClass('hide').addClass("animate-show ".concat(directionClasses[direction].show, " animate-time-short"));
      svs.components.animation.add(itemToShow, "animate-show ".concat(directionClasses[direction].show, " animate-time-short"), () => {
        itemToShow.removeClass("animate-show ".concat(directionClasses[direction].show, " animate-time-short"));
      });
    });
  },
  nextItem() {
    let nextItemIndex;
    let currentItemIndex;
    const limitItems = this.getUI('limitItems');
    limitItems.each(function (index) {
      if (!$(this).hasClass('hide')) {
        currentItemIndex = index;
      }
    });
    nextItemIndex = currentItemIndex + 1;
    if (nextItemIndex >= limitItems.length) {
      nextItemIndex = 0;
    }
    svs.components.analytics.trackEvent({
      category: 'login-info',
      opt_label: 'gränser',
      opt_action: this.limits[nextItemIndex]
    });
    this.animateLimits(limitItems, currentItemIndex, nextItemIndex, 'right');
  },
  prevItem() {
    let nextItemIndex;
    let currentItemIndex;
    const limitItems = this.getUI('limitItems');
    limitItems.each(function (index) {
      if (!$(this).hasClass('hide')) {
        currentItemIndex = index;
      }
    });
    nextItemIndex = currentItemIndex - 1;
    if (nextItemIndex < 0) {
      nextItemIndex = limitItems.length - 1;
    }
    svs.components.analytics.trackEvent({
      category: 'login-info',
      opt_label: 'gränser',
      opt_action: this.limits[nextItemIndex]
    });
    this.animateLimits(limitItems, currentItemIndex, nextItemIndex, 'left');
  }
});

 })(window);